import CompaniesTab from '../components/system/CompaniesTab';

const Companies = () => {

  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow min-h-0">
        <CompaniesTab />
      </div>
    </div>
  );
};

export default Companies;
